import Mint1Contract from "./abis/mint-1/MintableNFT.json";
import Mint2Contract from "./abis/mint-2/MintableNFT.json";

export const NFT_CONTRACTS_ABIS = [Mint1Contract as any, Mint2Contract as any];